import React, { useEffect, useState } from "react";
import { makeStyles } from "@mui/styles";
import Breadcrumb from "../../../App/Components/Navigation/Breadcrumbs/Breadcrumbs";
import {
  Button,
  Card,
  CardContent,
  Dialog,
  FormHelperText,
  Grid,
  TextField,
} from "@mui/material";
import { useLocation, Redirect } from "react-router-dom";
import { callAPI } from "../../../App/Helpers/callApi";
import Signifier from "../../../App/Components/Signifier/Signifier";
import { useSelector } from "react-redux";
import { basicConvertDate } from "../../../App/Helpers/DateConverters";
import {
  activate,
  deleteUser,
  editUser,
  resetPassword,
} from "../../../App/Services/UserService";
import ConfirmationModal from "../../../App/Components/Modals/ConfirmationModal";
import { selectClientValue } from "../../../App/State/Slices/SelectedClientSlice";

function UserDetailed() {
  const useStyles = makeStyles((theme) => ({
    root: {
      width: "90%",
      marginBottom: "50px",
      [theme.breakpoints.down("md")]: {
        width: "100%",
      },
    },
    error: {
      color: theme.palette.error.main,
    },
    cardContainer: {
      [theme.breakpoints.down("md")]: {
        width: "100%",
        overflowY: "scroll",
      },
      display: "flex",
      flexDirection: "column",
      marginBottom: "20px",
      width: "50%",
    },
    header: {
      [theme.breakpoints.down("md")]: {
        flexDirection: "column",
        marginTop: "10px",
      },
      display: "flex",
    },
    descBlock: {
      display: "flex",
    },
    descLabel: {
      margin: "0px",
      fontWeight: "700",
      marginBottom: "10px",
    },
    descValue: {
      margin: "0px",
      marginLeft: "5px",
      marginRight: "20px",
    },
    copy: {
      color: theme.palette.primary.copy,
    },
    sensitiveSection: {
      width: "100%",
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
      paddingTop: "20px",
    },
    sensitiveButton: {
      [theme.breakpoints.down("md")]: {
        maxWidth: "none",
        width: "100%",
        marginBottom: "15px",
      },
      width: "200px",
    },
  }));

  const classes = useStyles();

  let location = useLocation();
  const [showSignifier, setShowSignifier] = useState(false);
  const [responseMessage, setResponseMessage] = useState("");
  const [showError, setShowError] = useState(false);
  const [processing, setProcessing] = useState(false);
  const selectedClient = useSelector(selectClientValue);
  const [clientId, setClientId] = useState("");

  const [deleted, setDeleted] = useState(false);

  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");

  const [deleteModal, setDeleteModal] = useState(false);
  const [resetModal, setResetModal] = useState(false);
  const [activateModal, setActivateModal] = useState(false);

  const [inputError, setInputError] = useState(false);

  const checkInput = () => {
    if (
      firstName === "" ||
      lastName === "" ||
      email === "" ||
      (phone.length > 0 && phone.length < 7)
    ) {
      setInputError(true);
      return false;
    }
    return true;
  };

  const saveInformation = () => {
    if (checkInput()) {
      var data = {
        FirstName: firstName,
        LastName: lastName,
        EmailAddress: email,
        PhoneNumber: phone,
      };
      callAPI(
        editUser(location.state?.userId, data),
        "User Saved",
        setShowSignifier,
        setResponseMessage,
        setShowError,
        setProcessing
      );
    }
  };

  const callDelete = () => {
    callAPI(
      deleteUser(location.state.user.id),
      "User Deleted",
      setShowSignifier,
      setResponseMessage,
      setShowError,
      setProcessing
    ).then((res) => {
      setDeleted(true);
    });
  };

  useEffect(() => {
    if (location.state !== null && location.state !== undefined) {
      setClientId(location.state.baseClientId);
      setFirstName(location.state?.user?.firstName);
      setLastName(location.state?.user?.lastName);
      setEmail(location.state?.user?.emailAddress);
      setPhone(location.state?.user?.phoneNumber);
    }
  }, []);

  if (location.state === null || location.state === undefined) {
    return <Redirect to="/users" />;
  }

  if (selectedClient.id !== clientId && clientId !== "") {
    return <Redirect to="/users" />;
  }

  if (deleted) {
    return <Redirect to="/users" />;
  }

  return (
    <>
      <Signifier
        showSignifier={showSignifier}
        setShowSignifier={setShowSignifier}
        message={responseMessage}
        error={showError}
      />
      <div className="page-container">
        <Breadcrumb />
        <h1 className="page-title">
          {selectedClient.clientName} User Detailed
        </h1>
        <div className={classes.root}>
          <div className={classes.header}>
            <div className={classes.descBlock}>
              <p className={classes.descLabel}>DATE CREATED: </p>
              <p className={classes.descValue}>
                {basicConvertDate(location.state?.user?.dateCreated)}
              </p>
            </div>
            <div className={classes.descBlock}>
              <p className={classes.descLabel}>DATE LAST UPDATED: </p>
              <p className={classes.descValue}>
                {basicConvertDate(location.state?.user?.dateLastUpdated)}
              </p>
            </div>
          </div>
          <Grid className={classes.cardContainer}>
            <Card className={classes.card}>
              <CardContent>
                <Grid container spacing={1}>
                  <Grid xs={12} sm={6} item>
                    <TextField
                      placeholder="First Name"
                      label="First Name"
                      variant="standard"
                      fullWidth
                      required
                      InputProps={{
                        className: classes.copy,
                      }}
                      value={firstName}
                      onChange={(e) => setFirstName(e.target.value)}
                      error={inputError && firstName === ""}
                      helperText={
                        inputError && firstName === ""
                          ? "First Name Required"
                          : ""
                      }
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      placeholder="Last Name"
                      label="Last Name"
                      variant="standard"
                      fullWidth
                      required
                      InputProps={{
                        className: classes.copy,
                      }}
                      value={lastName}
                      onChange={(e) => setLastName(e.target.value)}
                      error={inputError && lastName === ""}
                      helperText={
                        inputError && lastName === ""
                          ? "Last Name Required"
                          : ""
                      }
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      placeholder="Email"
                      label="Email"
                      variant="standard"
                      fullWidth
                      required
                      InputProps={{
                        className: classes.copy,
                      }}
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      error={inputError && email === ""}
                      helperText={
                        inputError && email === ""
                          ? "Email Address Required"
                          : ""
                      }
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      placeholder="Phone Number"
                      label="Phone Number"
                      variant="standard"
                      fullWidth
                      InputProps={{
                        className: classes.copy,
                      }}
                      value={phone}
                      onChange={(e) => setPhone(e.target.value)}
                      error={inputError && phone.length > 0 && phone.length < 7}
                      helperText={
                        inputError && phone.length > 0 && phone.length < 7
                          ? "Invalid Phone Number"
                          : ""
                      }
                    />
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    container
                    justifyContent="flex-end"
                  >
                    <Button
                      style={{ marginTop: "20px", marginRight: "8px" }}
                      className={classes.sensitiveButton}
                      type="submit"
                      variant="contained"
                      color="primary"
                      onClick={() => saveInformation()}
                    >
                      Save Information
                    </Button>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
            <div className={classes.sensitiveSection}>
              <Grid
                item
                xs={12}
                sm={12}
                container
                justifyContent="space-between"
              >
                <Button
                  className={classes.sensitiveButton}
                  type="submit"
                  variant="contained"
                  color="secondary"
                  onClick={() => setDeleteModal(true)}
                >
                  Delete Account
                </Button>
                <div>
                  <Button
                    style={{ marginRight: "20px" }}
                    className={classes.sensitiveButton}
                    type="submit"
                    variant="contained"
                    color="primary"
                    onClick={() => setResetModal(true)}
                  >
                    Reset Password
                  </Button>
                  <Button
                    className={classes.sensitiveButton}
                    type="submit"
                    variant="contained"
                    color="primary"
                    onClick={() => setActivateModal(true)}
                  >
                    {location.state.user?.isActive
                      ? "Deactivate Account"
                      : "Activate Account"}
                  </Button>
                </div>
              </Grid>
            </div>
          </Grid>
        </div>
      </div>
      <Dialog open={activateModal} onClose={() => setActivateModal(false)}>
        <ConfirmationModal
          question={
            location.state.user?.isActive
              ? "Block NAS access to this account?"
              : "Unblock NAS access to this account?"
          }
          func={() => {
            location.state.user.isActive
              ? callAPI(
                  activate(location.state.user?.id, false),
                  "User Deactivated",
                  setShowSignifier,
                  setResponseMessage,
                  setShowError,
                  setProcessing
                )
              : callAPI(
                  activate(location.state.user?.id, true),
                  "User Activated",
                  setShowSignifier,
                  setResponseMessage,
                  setShowError,
                  setProcessing
                );
          }}
          closeModal={() => setActivateModal(false)}
        />
      </Dialog>
      <Dialog open={deleteModal} onClose={() => setDeleteModal(false)}>
        <ConfirmationModal
          question="Delete this account permanently?"
          func={() => callDelete()}
          closeModal={() => setDeleteModal(false)}
        />
      </Dialog>
      <Dialog open={resetModal} onClose={() => setResetModal(false)}>
        <ConfirmationModal
          question="Send this account an email to reset password?"
          func={() =>
            callAPI(
              resetPassword(location.state.user.emailAddress),
              "Password Reset Sent",
              setShowSignifier,
              setResponseMessage,
              setShowError,
              setProcessing
            )
          }
          closeModal={() => setResetModal(false)}
        />
      </Dialog>
    </>
  );
}

export default UserDetailed;
